<template>
    <div class="notify-container">
        <transition-group name="notify" tag="div">
            <div v-for="(note, index) in notifications" :key="note.id" class="notify-card" :class="note.status"
                :style="{ bottom: `${20 + index * 64}px` }">
                <!-- lớp glow -->
                <div class="notify-glow"></div>

                <!-- nội dung -->
                <span class="notify-text">
                    {{ note.message }}
                </span>
            </div>
        </transition-group>
    </div>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    import { EventBus } from '@/utils/eventBus'

    const notifications = ref([])
    let nextId = 1

    function showNotify(payload) {
        const { message, status = 'info' } = payload
        const id = nextId++

        notifications.value.push({ id, message, status })

        // Tự động ẩn sau 3s
        setTimeout(() => {
            const index = notifications.value.findIndex(n => n.id === id)
            if (index !== -1) notifications.value.splice(index, 1)
        }, 3000)
    }

    onMounted(() => {
        EventBus.on('notify:show', showNotify)
    })

    onUnmounted(() => {
        EventBus.off('notify:show', showNotify)
    })
</script>

<style scoped>
    /* ===== CONTAINER ===== */
    .notify-container {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 9999;
        pointer-events: none;
    }

    /* ===== CARD ===== */
    .notify-card {
        position: absolute;
        right: 0;

        min-width: 260px;
        max-width: 360px;
        padding: 14px 18px;
        border-radius: 14px;

        background: rgba(255, 255, 255, 0.88);
        backdrop-filter: blur(14px);

        box-shadow:
            0 14px 32px rgba(0, 0, 0, 0.18),
            0 6px 14px rgba(0, 0, 0, 0.10);

        display: flex;
        align-items: center;
        overflow: hidden;
    }

    /* ===== TEXT ===== */
    .notify-text {
        font-size: 14px;
        font-weight: 500;
        color: #1f2937;
        line-height: 1.4;
        z-index: 2;
    }

    /* ===== GLOW ===== */
    .notify-glow {
        position: absolute;
        inset: -20%;
        opacity: 0.5;
        filter: blur(28px);
        z-index: 1;
    }

    /* ===== STATUS COLOR ===== */
    .notify-card.success .notify-glow {
        background: radial-gradient(circle, rgba(34, 197, 94, 0.9), transparent 70%);
    }

    .notify-card.error .notify-glow {
        background: radial-gradient(circle, rgba(239, 68, 68, 0.9), transparent 70%);
    }

    .notify-card.warning .notify-glow {
        background: radial-gradient(circle, rgba(245, 158, 11, 0.9), transparent 70%);
    }

    .notify-card.info .notify-glow {
        background: radial-gradient(circle, rgba(59, 130, 246, 0.9), transparent 70%);
    }

    /* ===== ANIMATION ===== */
    .notify-enter-from {
        opacity: 0;
        transform: translateX(40px) scale(0.95);
    }

    .notify-enter-to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }

    .notify-leave-from {
        opacity: 1;
        transform: translateX(0) scale(1);
    }

    .notify-leave-to {
        opacity: 0;
        transform: translateX(40px) scale(0.96);
    }

    .notify-enter-active,
    .notify-leave-active {
        transition: all 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);
    }
</style>